import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["name", "colorContainer"]

    connect() {
        this.color = '#ef4444' // Default color
    }

    selectColor(event) {
        this.color = event.target.value
    }

    async create(event) {
        event.preventDefault()

        const name = this.nameTarget.value
        if (!name) return

        const csrfToken = document.querySelector('meta[name="csrf-token"]').content

        try {
            const response = await fetch('/labels', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken,
                    'Accept': 'text/vnd.turbo-stream.html'
                },
                body: JSON.stringify({
                    label: {
                        name: name,
                        color: this.color
                    }
                })
            })

            if (response.ok) {
                const html = await response.text()
                Turbo.renderStreamMessage(html)
                this.reset()
            } else {
                console.error("Failed to create label")
            }
        } catch (error) {
            console.error("Error creating label:", error)
        }
    }

    reset() {
        this.nameTarget.value = ""
        // Close dropdown (hacky but works with existing dropdown controller)
        const dropdownToggle = this.element.closest('[data-controller="dropdown"]').querySelector('[data-action="dropdown#toggle"]')
        if (dropdownToggle) dropdownToggle.click()
    }
}
